import { LFDynamicWidgetConfig } from './lf-dynamic-widget-config';

export class PageDisplayConfig {

    public layoutType: string = 'default-accordion';

    public columnGroupWidgetList: Array<LFDynamicWidgetConfig>;

    public columnGroupComponentConfig: any;

    public messageConfig: any;

    public static editMode = 'E';
    public static viewMode = 'V';
    public static createMode = 'C';
}

export class CBolDcCodePageConfig {
    public static dccode: string = 'dcCode';
}

export class StorerFieldConfig {
    public static storerType = 'storerType';
    public static storerTypeValueOne = 1;
    public static storertableId = 'storertd';
    public static storeridProperty = 'storerName';
    
}

export class PopulateType{
    public static populate = 'populate';
    public static populateAll = 'populateAll';
    public static readonly Adjustment = 'Adjustment';
}

export class RequestParamConstants{
    public static warningMessageN = 'N';
    public static warningMessageY = 'Y';
    public static warningNumber0  = '0';
    public static warningNumber1  = '1';

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/models/page-display-config.ts